jQuery( async ( $ ) => {
	const dateTranslations = await $.get( red61.ajax_url, {
		action: 'get_translations',
		component: 'date',
	} );

	moment.locale( dateTranslations.language, dateTranslations.translations );

	const createInput = ( name, id, value ) => {
		return $( '<input>', { name: name, id: id, value: value, type: 'hidden' } );
	};
	const homeData = $( '#home-data' ).data();

	const todayHighlight = homeData && homeData.startDate ? false : true;

	const datepicker = $( '#datetimepicker2' );
	const datepicker2 = $( '#datetimepicker2-mobile' );

	const { language } = dateTranslations;
	const {
		weekdays,
		weekdaysShort,
		weekdaysMin,
		months,
		monthsShort,
		today,
		clear,
		format,
		titleFormat,
		weekStart,
	} = dateTranslations.translations;

	$.fn.datepicker.dates[dateTranslations.language] = {
		days: weekdays,
		daysShort: weekdaysShort,
		daysMin: weekdaysMin,
		months,
		monthsShort,
		today,
		clear,
		format,
		titleFormat,
		weekStart,
	};

	const getParameterByName = ( name, url ) => {
		if ( !url ) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&"); //eslint-disable-line
		const regex = new RegExp( `[?&]${name}(=([^&#]*)|&|#|$)` ),
			results = regex.exec( url );
		if ( !results ) return null;
		if ( !results[2] ) return '';
		return decodeURIComponent( results[2].replace( /\+/g, ' ' ) );
	};

	function getParametersByName( name ) {
		const qs = location.search;

		const params = [];
		let tokens;
		const re = /[?&]?([^=]+)=([^&]*)/g;

		while ( ( tokens = re.exec( qs ) ) ) {
			if ( decodeURIComponent( tokens[1] ) == name )
				params.push( decodeURIComponent( tokens[2] ) );
		}

		return params;
	}

	function addPresentationFormatToQueryParams( checkbox, $form ) {
		if ( checkbox.checked ) {
			$form
				.find( 'input.presentation-format-radio-input[type=checkbox]' )
				.each( function () {
					checkbox.removeAttr( 'name' );
				} );
				
			if ( $form.find( '#presentation_format' ).length ) {
				$form.find( '#presentation_format' ).val( checkbox.value );
			} else {
				$form.append( createInput( 'presentation_format', 'presentation_format', checkbox.value ) );
			}
		}
	}

	function selectAgeSuitabilityCheckboxes() {
		getParametersByName( 'age_suitability_codes' ).forEach( ( element ) => {
			$( `input[value="${element}"]` ).prop( 'checked', true );
		} );
	}
	selectAgeSuitabilityCheckboxes();

	$( '.three-line-clamp' ).each( ( index, element ) => {
		$clamp( element, { clamp: 3 } );
	} );
	$( '.one-line-clamp' ).each( ( index, element ) => {
		$clamp( element, { clamp: 1 } );
	} );
	$( '.two-line-clamp' ).each( ( index, element ) => {
		$clamp( element, { clamp: 2 } );
	} );

	$( '.main-cards' ).on( 'click', '.card', function ( event ) {
		event.preventDefault();
		window.location.href = $( this ).find( 'a' ).attr( 'href' );
	} );

	$( '.search-trigger' ).click( function ( event ) {
		event.preventDefault();
		$( this ).closest( 'form' ).submit();
	} );

	$( '#home-page-menu-bars-filter-icon-mobile' ).click(
		function () {
			$( '#home-page-calendar-mobile-wrapper' ).toggleClass( 'display-none' );
			$( '#home-page-calendar-mobile-wrapper-padding' ).toggleClass( 'display-none' );
			$( '#home-page-menu-bars-filter-mobile-wrapper' ).toggleClass( 'display-none' );
			$( '#home-page-menu-bars-filter-mobile-wrapper-padding' ).toggleClass( 'display-none' );
		},
	);

	//Event type radio buttons
	$( '.presentation-format-radio-input' ).click( function () {
		const $form = $( '.main_search' ).find( 'form' );
		addPresentationFormatToQueryParams( this, $form );
	} );

	//Calendar date picker desktop
	const $picker = datepicker
		.datepicker( {
			inline: true,
			multidate: false,
			debug: true,
			todayHighlight: todayHighlight,
			maxViewMode: 1,
			format: 'dd/mm/yyyy',
			weekStart,
			language,
			beforeShowDay: function ( date ) {
				$( '#ui-datepicker-div' ).css( 'clip', 'auto' );
				if ( $picker && 2 === $picker.datepicker( 'getDates' ).length ) {
					const selectedDates = $picker.datepicker( 'getDates' );
					const startDate = moment( selectedDates[0] );
					const endDate = moment( selectedDates[1] );
					const day = moment( date );
					if ( day.isAfter( startDate ) && day.isBefore( endDate ) ) {
						return {
							enabled: true,
							classes: 'active',
						};
					}
				}
			},
		} )
		.on( 'changeDate', ( event ) => {
			const startDate = moment( event.dates[0] ).format( 'DD/MM/YYYY' );
			$( '#datetimepicker2' ).find( '.today' ).removeClass( 'today' );
			const $form = $( '.main_search' ).find( 'form' );
			const $input = $( '<input>', {
				name: 'start_date',
				id: 'start_date',
				value: startDate,
				type: 'hidden',
			} );
			if ( $form.find( '#start_date' ).length ) {
				$form.find( '#start_date' ).val( startDate );
			} else {
				$form.append( $input );
			}
		} );

	//Calendar date picker mobile
	const $picker2 = datepicker2
		.datepicker( {
			inline: true,
			multidate: false,
			debug: true,
			todayHighlight: todayHighlight,
			maxViewMode: 1,
			format: 'dd/mm/yyyy',
			weekStart,
			language,
			beforeShowDay: function ( date ) {
				if ( $picker2 && 2 === $picker.datepicker( 'getDates' ).length ) {
					const selectedDates = $picker.datepicker( 'getDates' );
					const startDate = moment( selectedDates[0] );
					const endDate = moment( selectedDates[1] );
					const day = moment( date );
					if ( day.isAfter( startDate ) && day.isBefore( endDate ) ) {
						return {
							enabled: true,
							classes: 'active',
						};
					}
				}
			},
		} )
		.on( 'changeDate', ( event ) => {
			const startDate = moment( event.dates[0] ).format( 'DD/MM/YYYY' );
			const $form = $( '.main_search' ).find( 'form' );
			$( '#datetimepicker2-mobile' ).find( '.today' ).removeClass( 'today' );
			const $input = $( '<input>', {
				name: 'start_date',
				id: 'start_date',
				value: startDate,
				type: 'hidden',
			} );
			if ( $form.find( '#start_date' ).length ) {
				$form.find( '#start_date' ).val( startDate );
			} else {
				$form.append( $input );
			}
		} );

	//Time range slider
	const $range = $( '.range_37' ).ionRangeSlider( {
			values_separator: " - ", // eslint-disable-line
		skin: 'round',
		type: 'double',
		min: +moment().startOf( 'day' ).format( 'X' ),
		max: +moment().endOf( 'day' ).format( 'X' ),
		from: getParameterByName( 'from_sec' )
			? getParameterByName( 'from_sec' )
			: +moment().startOf( 'day' ).format( 'X' ),
		to: getParameterByName( 'to_sec' )
			? getParameterByName( 'to_sec' )
			: +moment().endOf( 'day' ).format( 'X' ),
		prettify: function ( num ) {
			const m = moment( num, 'X' );
			return m.format( 'HH:mm' );
		},
		onFinish: function ( event ) {
			const $form = $( '.main_search' ).find( 'form' );
			const $from = createInput( 'from', 'from_pretty_time', event.from_pretty );
			const $to = createInput( 'to', 'to_pretty_time', event.to_pretty );
			const $fromSec = createInput( 'from_sec', 'from_time', event.from );
			const $toSec = createInput( 'to_sec', 'to_time', event.to );
			
			if ( $form.find( '#from_time' ).length ) {
				$form.find( '#from_pretty_time' ).val( event.from_pretty );
				$form.find( '#to_pretty_time' ).val( event.to_pretty );
				$form.find( '#from_time' ).val( event.from );
				$form.find( '#to_time' ).val( event.to );
			} else {
				$form.append( $from );
				$form.append( $to );
				$form.append( $fromSec );
				$form.append( $toSec );
			}
		},
	} );
	$range.on( 'finish', function () {} );

	//Age suitability
	$( '.check-filter-age-suitability' ).on(
		'change',
		'.checkbox-style',
		function () {
			const $form = $( '.main_search' ).find( 'form' );
			// let i = 0;
			$( 'input[name="ageSuitabilityCodes[]"]:checked' ).each( function () {
				const $input = $( '<input>', {
					name: 'age_suitability_codes[]',
					id: `age_suitability_codes_${this.value}`,
					value: this.value,
					type: 'hidden',
				} );
				if ( $form.find( `#age_suitability_codes_${this.value}` ).length ) {
					$form.find( `#age_suitability_codes_${this.value}` ).val( this.value );
				} else {
					$form.append( $input );
				}
				// i++;
			} );
			
		}
	);

	//Apply filter button submit
	$( '.apply-filter' ).click( function ( event ) {
		const $form = $( '.main_search' ).find( 'form' );
		event.preventDefault();
		$form.submit();
	} );
	
	$( window ).bind( 'hashchange', function(){
		const $form = $( '.main_search' ).find( 'form' );
		const queryString = window.location.search;
		const urlParams = new URLSearchParams( queryString );
		const presentationformat = urlParams.get( 'presentation_format' );
		const startDate = urlParams.get( 'start_date' );
		const from = urlParams.get( 'from' );
		const to = urlParams.get( 'to' );
		const fromSec = urlParams.get( 'from_sec' );
		const toSec = urlParams.get( 'to_sec' );
	
		const ageSuitabilityCodes = urlParams.getAll( 'age_suitability_codes[]' );
		
		if( presentationformat ){ 
			$form.append( createInput( 'presentation_format', 'presentation_format', presentationformat ) ); 
		}
		if( startDate ){ 
			$form.append( createInput( 'start_date', 'start_date', startDate ) ); 
		}
		if( from ){ 
			$form.append( createInput( 'from', 'from_pretty_time', from ) ); 
			$form.append( createInput( 'to', 'to_pretty_time', to ) );
			$form.append( createInput( 'from_sec', 'from_time', fromSec ) );
			$form.append( createInput( 'to_sec', 'to_time', toSec ) ); 
		}
		if( ageSuitabilityCodes ){
			for ( const value of ageSuitabilityCodes ) {
				$form.append( createInput( 'age_suitability_codes[]', `age_suitability_codes_${value}`, value ) );
			}
			$( '.checkbox-style' ).change( function() {
				const value = $( this ).val(),
					$form = $( '.main_search' ).find( 'form' );
				if ( this.checked ) {
					$form.append( createInput( 'age_suitability_codes[]', `age_suitability_codes_${value}`, value ) );
				}else {
					$form.find( `input[id=age_suitability_codes_${value}` ).slideUp( 'fast', function() {
						$( this ).remove();
					} );
				}
			} );
		}
	} ).trigger( 'hashchange' );

	//main search
	$( '.main_search' ).on( 'change', 'select', function () {
		const $form = $( '.main_search' ).find( 'form' );
		$form.submit();
	} );
	
	//Sub filter/genre
	$( '.check-filter' ).on( 'change', '.checkbox-style', function () {
		const $form = $( '.main_search' ).find( 'form' );
		$( '.checkbox-style' ).not( this ).prop( 'checked', false );
		if ( this.checked ) {
			$form.find( 'select[name="event_type"]' ).removeAttr( 'name' );
			const $input = $( '<input>', {
				name: 'event_type',
				value: this.value,
				type: 'hidden',
			} );
			$form.append( $input );
		} else {
			$form.submit();
		}
	} );

	if ( homeData && homeData.startDate ) {
		const dates = [];
		dates.push( homeData.startDate );
		if ( homeData.endDate ) {
			dates.push( homeData.endDate );
		}
		$picker.datepicker( 'setDates', dates, true );
	}
} );